import { useNavigate } from 'react-router';
import { SearchHookProps, SearchResultItem } from '../interfaces/global-search';
import { useLazyGetTrainingMaterialQuery } from '../redux/features/dokument-trajnimi/dokument-trajnimi-api';
import { downloadFile } from '../helpers/download-links';
import { NotificationError } from '../components/common/common-componnets/Notifications';
import { useState } from 'react';
import {
  DOKUMENT,
  EKSPERT_TRAJNIMI,
  EVIDENCA,
  KANDIDAT,
  LISTE_PREZENCA,
  navigateWithSearchState,
  PEDAGOG,
  PJESEMARRES,
  TRAJNIM_PREZENCA,
  TRAJNIMI,
} from '../components/common/common-functions/common-functions';
import { Module } from '../utilities/enums';
import { useLazyExportDocumentPerTopicQuery } from '../redux/features/lenda/lende-viti-akademikApi';
import { useRoleGetter } from '../helpers/getUserInfo';

export const useSearchAction = ({
  onClose,
  selectedModule,
}: SearchHookProps) => {
  const [downloadingId, setDownloadingId] = useState<number>();
  const navigate = useNavigate();
  const role = useRoleGetter();

  const [getTrainingMaterial, { isLoading: isLoadingTraining }] =
    useLazyGetTrainingMaterialQuery();
  const [exportDocumentPerTopic, { isLoading: isLoadingExport }] =
    useLazyExportDocumentPerTopicQuery();

  const isLoading = isLoadingTraining || isLoadingExport;

  const handleFileDownload = (id: number, trainingName: string) => {
    if (id) {
      setDownloadingId(id);

      const fetcher =
        selectedModule === Module.FF
          ? exportDocumentPerTopic
          : getTrainingMaterial;

      fetcher({ id, role })
        .unwrap()
        .then(res => downloadFile(res, trainingName))
        .catch(() => NotificationError('Materiali nuk u ruajt!'));
    }
  };

  const handleResultClick = (result: SearchResultItem) => {
    const entityId = result.entityReference?.redirectId;

    if (selectedModule === Module.KONKURRIME) {
      navigate(`/konkurrime/aplikim/${entityId}`);
      onClose();
      return;
    }

    if (selectedModule === Module.FF) {
      if (result?.category === DOKUMENT) {
        navigateWithSearchState(navigate, '/lende-mesimore', result);
        onClose();
        return;
      }

      if (result?.category === LISTE_PREZENCA) {
        navigateWithSearchState(navigate, '/list-prezenca', result);
        onClose();
        return;
      }

      if (result?.category === EVIDENCA) {
        navigateWithSearchState(navigate, '/evidenca', result);
        onClose();
        return;
      }
    }

    switch (result.category) {
      case TRAJNIMI:
      case DOKUMENT:
      case TRAJNIM_PREZENCA:
      case EKSPERT_TRAJNIMI:
        navigateWithSearchState(
          navigate,
          `/trajnime-kalendari/${entityId}`,
          result,
        );
        break;

      case PJESEMARRES:
        navigateWithSearchState(
          navigate,
          '/administrim-formimiVazhdues',
          result,
        );
        break;

      case KANDIDAT:
      case PEDAGOG:
        navigateWithSearchState(
          navigate,
          '/administrim-formimiFillestar',
          result,
        );
        break;
    }

    onClose();
  };

  return { handleFileDownload, handleResultClick, isLoading, downloadingId };
};
